// extracted by mini-css-extract-plugin
export default {"main":"RoomItem_main__jJUwp","info":"RoomItem_info__FhcIV","selected":"RoomItem_selected__z5Md4"};